import React from 'react';
import {Signup} from './container';

export const SignupScreen = () => {
  return <Signup />;
};
